import React from 'react';

const Controls = ({ onShowHelp }) => {
    const handleBackToSite = () => {
        // Повернення на головний сайт КПІ
        window.location.href = 'https://pgm.kpi.ua/';
    };

    return (
        <div className="virtual-tour-controls">
            <button className="control-btn" onClick={onShowHelp}>
                <span className="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <path fill="#008cff" d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8a8 8 0 0 1-8 8" />
                        <circle cx="12" cy="8" r="1" fill="#008cff" />
                        <path fill="#008cff" d="M12 10a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1" />
                    </svg>
                </span>
                <span>Довідка</span>
            </button>

            <button className="control-btn" onClick={handleBackToSite}>
                <span className="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <path fill="#008cff" d="M10 19v-5h4v5c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-7h1.7c.46 0 .68-.57.33-.87L12.67 3.6c-.38-.34-.96-.34-1.34 0l-8.36 7.53c-.34.3-.13.87.33.87H5v7c0 .55.45 1 1 1h3c.55 0 1-.45 1-1" />
                    </svg>
                </span>
                <span>На головну</span>
            </button>
        </div>
    );
};

export default Controls;
